import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DiningsPageComponent } from '../../../components/dinings-page/dinings-page.component';
import { DiningDetailsPageComponent } from '../../../components/dining-details-page/dining-details-page.component';

@Component({
  selector: 'app-dining-route-decision',
  standalone: true,
  imports: [DiningsPageComponent, DiningDetailsPageComponent ],
  templateUrl: './dining-route-decision.component.html',
  styleUrl: './dining-route-decision.component.scss',
})
export class DiningRouteDecisionComponent {
  type: string = '';
  routeData: any;

  constructor(private router: Router, private route: ActivatedRoute) {
    this.route.data.subscribe(({ decision }) => {
      this.type = decision?.type;
      this.routeData = decision?.data;
      if (decision?.type === '404') {
        this.router.navigate(['/404']);
      }
    });
  }
}
